import useAppSelector from '@/hooks/useAppSelector'
import { selectSessionMetadata } from '@/redux/slices/session'

export function useSessionMetadata() {
  return useAppSelector(selectSessionMetadata)
}
